import Layout from '../../components/Layout/Layout'
import Hero, { HeroVariantEnum } from '../../components/Hero/Hero'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import axios from 'axios'
import theme from '../../theme/theme-style'
import { ImpulseSpinner } from '../../components/Loading/ImpulseSpinner'
import Heading from '../../components/Heading/Heading'
import HeadingSizeEnum from '../../enums/headingSize'
import { deviceMax } from '../../theme/breakpoints'
import Button from '../../components/Button/Button'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import SearchBarSmall from '../../components/SearchBarSmall/SearchBarSmall'
import FilterJobs from '../../components/FilterJobs/FilterJobs'
import Seo from '../../components/Seo/Seo'
import { graphql, Link, navigate } from 'gatsby'
import { jobSearch, suggest } from '../../routes/apiRoutes'
import SearchPaginator from '../../components/SearchPaginator/SearchPaginator'
import getJobFiltersList from '../../utils/getJobFiltersList'
import { MainContainer } from '../../theme/mainContainer.styled'
import LocalesEnum from '../../enums/LocalesEnum'
import NumOfResultsEnum from '../../enums/jobSearch/NumOfResultsEnum'
import StartNewSearchEnum from '../../enums/jobSearch/StartNewSearchEnum'
import ResultsNumEnum from '../../enums/jobSearch/ResultsNumEnum'
import ApplyEnum from '../../enums/jobSearch/ApplyEnum'
import NoResults1Enum from '../../enums/jobSearch/NoResults1Enum'
import JobSearchEnum from '../../enums/jobSearch/JobSearchEnum'
import InterfaceLanguageEnum from '../../enums/jobSearch/InterfaceLanguageEnum'
import FormatedLanguageEnum from '../../enums/jobSearch/FormatedLanguageEnum'
import SelectComponent from '../../components/Select/Select'
import { slugifyFromNode } from '../../utils/UrlFactory'
import RoutingEnum from '../../routes/appRoutes'
import { filterJobEvent, jobMuscleShoalsEvent, searchEvent } from '../../utils/gtmEvents'
import parse from 'html-react-parser'
import useMediaQuery from '../../hooks/useMediaQuery'
import { paramsToObject } from '../../utils/AddParamToUrl'
import { API_APP_KEY } from '../../config/ApiConfig'

const SEOMETADESCRIPTION =
  'We are seeking talented, passionate and committed candidates who are as excited about the possibilities of aluminium as we are. Are you ready to join Constellium? Search and find our jobs, and apply online today!'
const NB_RESULTS = 12
const REGEX_DATE = '\\d+'

const StyledDiv = styled(MainContainer)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0 auto;
  gap: 0 ${pxToRem(20)};
  padding-top: 0;
`

const StyledRightSide = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: ${pxToRem(20)} 0;
  flex: 2;
  width: 100%;
  max-width: ${pxToRem(792)};
  height: fit-content;
  @media ${deviceMax.tablet} {
    align-items: center;
    padding: 0 ${pxToRem(10)};
  }
`

const StyledTitle = styled(Heading)``

const StyledCard = styled.div`
  background-color: ${({ theme }) => theme.colors.unique.white};
  padding: ${pxToRem(20)};
  width: 100%;
  max-width: ${pxToRem(792)};
  border-radius: ${pxToRem(5)};
`

const StyledCardTitle = styled(Heading)`
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  font-size: ${({ theme }) => theme.fonts.sizes.button};
  line-height: ${({ theme }) => theme.fonts.lineHeight.button};
`

const StyledCardDescription = styled.div`
  margin: ${pxToRem(10)} 0;
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH4};
  color: ${({ theme }) => theme.colors.opacity.black70};
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

const StyledFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const StyledApplyButton = styled(Button)`
  height: ${pxToRem(40)};
`

const StyledInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media ${deviceMax.tablet} {
    align-items: flex-start;
    flex-direction: column;
    margin-bottom: ${pxToRem(15)};
  }
`

const StyledSeperator = styled.div`
  width: ${pxToRem(20)};
  height: ${pxToRem(2)};
  background-color: ${({ theme }) => theme.colors.primary.lime};
  margin-right: ${pxToRem(10)};
`

const StyledCategory = styled.div`
  box-sizing: border-box;
  border: ${pxToRem(1)} solid #000000;
  backdrop-filter: blur(${pxToRem(10)});
  border-radius: ${pxToRem(40)};
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  font-size: ${({ theme }) => theme.fonts.sizes.md};
  line-height: ${({ theme }) => theme.fonts.lineHeight.md};
  text-align: center;
  padding: ${pxToRem(5)} ${pxToRem(20)};
  margin-right: ${pxToRem(10)};
  @media ${deviceMax.tablet} {
    margin-bottom: ${pxToRem(15)};
  }
`

const StyledPosition = styled.div`
  align-items: center;
  display: flex;
  text-transform: capitalize;
`

const StyledNoJobs = styled.div`
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
`

const StyledLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const SelectContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: ${pxToRem(792)};
  @media ${deviceMax.tablet} {
    max-width: none;
  }
`

const StyledSelect = styled(SelectComponent)`
  width: 100%;
  margin-bottom: ${pxToRem(20)};
  border-radius: ${pxToRem(5)};
  background-color: ${({ theme }) => theme.colors.unique.white};

  .react-select__control {
    border-width: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: ${pxToRem(2)} 0;
  }

  .react-select__indicator-separator {
    width: 0;
  }

  @media ${deviceMax.tablet} {
    margin: ${pxToRem(20)} 0 0 0;
  }
`

const StyledOption = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.unique.black};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
`

const StyledFilterJobsContainer = styled.div`
  display: block;
  @media ${deviceMax.tablet} {
    display: none;
  }
`

const StyledBold = styled.p`
  font-weight: ${({ theme }) => theme.fonts.weight.semibold};
  margin-left: ${pxToRem(2)};
`

const StyledTitleContainer = styled.div`
  width: fit-content;

  &:hover {
    div {
      width: 100%;
    }
  }
`

const StyledUnderline = styled.div`
  height: ${pxToRem(2)};
  width: 0%;
  background-color: ${({ theme }) => theme.colors.primary.blue};
  transition: all 0.3s ease;
`

const scrollTop = () => {
  // scroll top
  const scrollTop = document
    .querySelector('.requestScrollTo')
    .getBoundingClientRect().top

  if (window) {
    window?.scrollBy({
      top: scrollTop,
      left: 0,
      behavior: 'smooth',
    })
  }
}

// This page is currently use to display a list of all jobs
// in order to display each single job page
// This page need to be rework when ElasticSearch feature
// will be up

const JobSearch = ({ data, location }) => {
  const { filtersJobs } = data
  const [jobFilters, setJobFilters] = useState(filtersJobs)
  const [locale, setLocale] = useState(LocalesEnum.en)

  // useEffect(async () => {
  //   const allFilters = await axios.get(jobsFiltersUrl)
  //   setJobFilters(allFilters.data.data)
  // }, [])

  const isMobile = useMediaQuery(deviceMax.tablet)

  const isBrowser = typeof window !== `undefined`
  const hash = location.hash.slice(1)
  const urlParams = new URLSearchParams(hash)
  const jobs = data?.allJobs?.nodes
  const { q, nj, i, rp, c, s, l, cat, p } = paramsToObject(urlParams.entries())
  const locations = l ? l.split('_') : []
  const states = s ? s.split('_') : []
  const countries = c ? c.split('_') : []
  const categories = cat ? cat.split('_') : []

  const newjobs = nj ? JSON.parse(nj) : false
  const remotePosition = rp ? JSON.parse(rp) : false
  const internships = i ? JSON.parse(i) : false

  const initialFilters = {
    l: locations,
    s: states,
    c: countries,
    cat: categories,
    nj: newjobs,
    rp: remotePosition,
    i: internships,
  }
  const initialKeywords = q ?? ''
  const initialPage = p ? parseInt(p, 10) : 1
  const initialJobs =
    jobs?.slice(
      jobs.slice(
        initialPage * NB_RESULTS - NB_RESULTS,
        initialPage * NB_RESULTS,
      ),
    ) || []

  const [suggestions, setSuggestions] = useState([])
  const [keywords, setKeywords] = useState(initialKeywords)
  const [filters, setFilters] = useState(initialFilters)
  const [prevFilters, setPrevFilters] = useState(initialFilters)
  const [showFilters, setShowFilters] = useState(false)
  const [currentPage, setCurrentPage] = useState(initialPage)
  const [currentList, setCurrentList] = useState(initialJobs)
  const [nbOfResults, setNbOfResults] = useState(jobs.length)
  const [message, setMessage] = useState(
    jobs.length === 0 ? StartNewSearchEnum[locale] : null,
  )
  const [loading, setLoading] = useState(false)
  const [didMount, setDidMount] = useState(false)

  const initJobs = () => {
    if (keywords) return
    if (jobs) {
      if (didMount) {
        scrollTop()
      }
      setDidMount(true)
      setCurrentList(
        jobs.slice(
          currentPage * NB_RESULTS - NB_RESULTS,
          currentPage * NB_RESULTS,
        ),
      )
      setNbOfResults(jobs.length)
    } else {
      setMessage(StartNewSearchEnum[locale])
      setCurrentList([])
      setNbOfResults(0)
    }
  }

  const filtersList = getJobFiltersList(
    jobFilters,
    filters,
    setFilters,
    prevFilters,
    setPrevFilters,
  )

  useEffect(() => {
    handleAutocompletion(keywords)
    handleNewSearch(true)

    didMount &&  filterJobEvent({
      language: LocalesEnum.en,
      newJobs: filters.nj,
      internships: filters.i,
      remotePositions: filters.rp,
      countries: filters.c,
      states: filters.s,
      locations: filters.l,
      categories: filters.cat,
    })
  }, [filters])

  // muscle_shoals campaign
  useEffect(() => {
    if(l === 'Muscle Shoals' &&  c === 'United States') {
      didMount && jobMuscleShoalsEvent()
    }
  }, [didMount])

  useEffect(() => {
    const isInitial = isInitialSearch()
    if (isInitial) {
      initJobs()
      currentPage !== 1 && navigate(`#p=${currentPage}`)
      return
    }
    setDidMount(true)
    handleNewSearch(false)
  }, [currentPage])

  const nbOfPages = Math.ceil(nbOfResults / NB_RESULTS)

  const getParams = () => {
    const params = {}

    keywords && (params.q = keywords)
    currentPage && currentPage !== 1 && (params.p = currentPage)

    filters.l.length && (params.l = filters.l.join('_'))
    filters.s.length && (params.s = filters.s.join('_'))
    filters.c.length && (params.c = filters.c.join('_'))
    filters.cat.length && (params.cat = filters.cat.join('_'))
    filters.nj && (params.nj = JSON.stringify(filters.nj))
    filters.rp && (params.rp = JSON.stringify(filters.rp))
    filters.i && (params.i = JSON.stringify(filters.i))

    return params
  }

  const handleAutocompletion = async (newKeywords) => {
    if (!newKeywords) return setSuggestions([])
    try {
      const result = await axios.get(`${suggest}/jobs?code=${API_APP_KEY}`, {
        headers: {
          'Cache-Control': 'no-cache',
        },
        params: { q: newKeywords },
      })
      setSuggestions(result?.data)
    } catch (error) {
      console.error(error)
    }
  }

  const isInitialSearch = () => {
    const { c, cat, l, s, nj, rp, i } = filters
    if (
      c.length + l.length + s.length + cat.length === 0 &&
      !keywords &&
      !nj &&
      !rp &&
      !i
    ) {
      return true
    }
    return false
  }

  const handleNewSearch = async (paginationReset) => {
    if (loading) return

    setLoading(true)

    if (paginationReset && didMount) {
      setCurrentPage(1)
    }

    const params = getParams(paginationReset)

    const hash = new URLSearchParams(params).toString()
    hash ? navigate(`#${hash}`) : navigate(RoutingEnum.jobSearch)

    const from = paginationReset ? 0 : currentPage * NB_RESULTS - NB_RESULTS
    params.from = from

    const result = await axios.get(jobSearch, {
      headers: {
        'Cache-Control': 'no-cache',
      },
      params,
    })

    didMount && searchEvent({ language: locale, keywords })

    const isInitial = isInitialSearch()
    if (isInitial) {
      initJobs()
      setLoading(false)
      return
    }

    setCurrentList(result.data.jobs)
    setNbOfResults(result.data.total)

    if (result.data.total === 0) {
      setMessage(NumOfResultsEnum[locale])
    } else {
      setMessage(ResultsNumEnum[locale] + (result.data.total ?? 0))
    }
    setLoading(false)

    scrollTop()
  }

  const handleResetFilters = () => {
    const WithoutFilters = {
      l: [],
      s: [],
      c: [],
      cat: [],
      nj: false,
      rp: false,
      i: false,
    }
    setFilters(WithoutFilters)
  }

  const cards = currentList?.map((item) => {
    const title = item.searchable_title || item.title
    const description =
      item.searchable_description ||
      item.description.replace(/(<([^>]+)>)/gi, '')

    const sluggedTitle = slugifyFromNode(title)

    const link =
      RoutingEnum.jobSearch +
      '/' +
      item.id +
      '/' +
      sluggedTitle.replaceAll(' ', '-')

    const hasLocations = item.locations?.length > 0 ?? false

    const cardInformation = (
      <StyledInfo>
        {!isMobile && <StyledSeperator />}
        {item.category && item.category !== '' && (
          <StyledCategory>{item.category}</StyledCategory>
        )}
        {hasLocations && (
          <StyledPosition>
            {isMobile && <StyledSeperator />}
            {item.locations.length > 1
              ? 'Multiple locations'
              : `${item.locations[0]?.country} ${
                item.locations[0]?.state
                  ? '/ ' + item.locations[0]?.state
                  : ''
              } / ${item.locations[0]?.location}`}
          </StyledPosition>
        )}
      </StyledInfo>
    )

    return (
      <StyledCard key={item.id}>
        {isMobile && cardInformation}
        <StyledTitleContainer>
          <Link to={link}>
            <StyledCardTitle label={title} size={HeadingSizeEnum.h3} />
            <StyledUnderline />
          </Link>
        </StyledTitleContainer>
        <StyledCardDescription>{parse(description)}</StyledCardDescription>
        <StyledFooter>
          {!isMobile && cardInformation}
          <StyledApplyButton
            label={ApplyEnum[locale]}
            variant={ButtonVariantEnum.secondary}
            to={link}
          />
        </StyledFooter>
      </StyledCard>
    )
  })

  const LocaleSelect = () => {
    const options = Object.values(LocalesEnum).map((locale, index) => ({
      value: locale,
      label: (
        <StyledOption>
          {InterfaceLanguageEnum[locale]}
          <StyledBold>{FormatedLanguageEnum[locale]}</StyledBold>
        </StyledOption>
      ),
    }))

    return (
      <SelectContainer>
        <StyledSelect
          defaultValue={LocalesEnum.en}
          onChange={(e) => setLocale(e.select.value)}
          options={options}
          placeholder={
            <StyledOption>
              {InterfaceLanguageEnum[locale]}
              <StyledBold> {FormatedLanguageEnum[locale]}</StyledBold>
            </StyledOption>
          }
        />
      </SelectContainer>
    )
  }

  return (
    <Layout>
      <Seo
        title={JobSearchEnum[locale]}
        description={SEOMETADESCRIPTION}
        canonicalHref={RoutingEnum.jobSearch}
      />
      <Hero
        pathname={location.pathname}
        title={JobSearchEnum[locale]}
        variant={HeroVariantEnum.regular}
      />
      <SearchBarSmall
        handleAutocompletion={handleAutocompletion}
        handleNewSearch={handleNewSearch}
        keywords={keywords}
        setKeywords={setKeywords}
        suggestions={suggestions}
        locale={locale}
      >
        {filters && (
          <FilterJobs
            boxes={filtersList}
            isTablet
            showFilters={showFilters}
            filters={filters}
            locale={locale}
            setFilters={setFilters}
            resetFilters={() => {
              handleResetFilters()
            }}
            toggleFilters={() => {
              setShowFilters(true)
            }}
            onClose={() => {
              setShowFilters(false)
            }}
          />
        )}
        {isMobile && LocaleSelect()}
      </SearchBarSmall>
      <StyledDiv>
        <StyledFilterJobsContainer>
          {!isMobile && LocaleSelect()}
          {filters && (
            <FilterJobs
              boxes={filtersList}
              filters={filters}
              setFilters={setFilters}
              showFilters={showFilters}
              resetFilters={() => {
                handleResetFilters()
              }}
              onClose={() => {
                setShowFilters(false)
              }}
              locale={locale}
            />
          )}
        </StyledFilterJobsContainer>
        <StyledRightSide>
          {loading && (
            <StyledLoading>
              <ImpulseSpinner
                size={20}
                loading={true}
                frontColor={theme.colors.primary.blue}
              />
            </StyledLoading>
          )}
          {!loading && (
            <StyledTitle
              label={
                NumOfResultsEnum[locale] +
                ' : ' +
                (nbOfResults ? nbOfResults : 0)
              }
              size={HeadingSizeEnum.h3}
            />
          )}
          {!loading &&
            (nbOfResults ? nbOfResults : 0) === 0 &&
            keywords !== '' &&
            keywords !== null &&
            !isMobile && (
              <StyledNoJobs>
                <StyledTitle
                  label={NoResults1Enum[locale]}
                  size={HeadingSizeEnum.h5}
                />
              </StyledNoJobs>
            )}
          {!loading &&
            (nbOfResults ? nbOfResults : 0) === 0 &&
            (keywords === '' || keywords === null) &&
            !isMobile && (
              <StyledNoJobs>
                <StyledTitle
                  label={StartNewSearchEnum[locale]}
                  size={HeadingSizeEnum.h5}
                />
              </StyledNoJobs>
            )}
          {!loading && (nbOfResults ? nbOfResults : 0) === 0 && isMobile && (
            <StyledNoJobs>
              <StyledTitle
                label={NoResults1Enum[locale]}
                size={HeadingSizeEnum.h5}
              />
            </StyledNoJobs>
          )}
          {cards?.length !== 0 && cards}
          {!cards.length ||
            (nbOfResults > NB_RESULTS && (
              <SearchPaginator
                count={nbOfPages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            ))}
        </StyledRightSide>
      </StyledDiv>
    </Layout>
  )
}
export default JobSearch

export const jobs = graphql`
    query GetJobs {
        allJobs(sort: {publicationDate: DESC}) {
            nodes {
                title
                header
                footer
                category
                description
                id
                publicationDate
                isInternship
                locations {
                    country
                    state
                    location
                }
                remotePosition
            }
        }
        filtersJobs {
            categories
            filters {
                name
                states {
                    locations {
                        name
                    }
                    name
                }
            }
        }
    }
`
